module.exports = __webpack_public_path__ + "static/media/noun-what-you-get.eba46b9a.svg";